import { render } from "./AdDocViewTransactionsRemoveButton.vue?vue&type=template&id=d8aac5f6&ts=true"
import script from "./AdDocViewTransactionsRemoveButton.vue?vue&type=script&lang=ts"
export * from "./AdDocViewTransactionsRemoveButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__